define([
    'jQuery',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object'],
    function($, Widget, Object) {

        var LocationWidget = function(element, options) {
            Widget.apply(this, arguments);

            //Set options
            var defaultOptions = {
                'activeClassName': 'is-active',
                'labelCount': this.element.data('label-count'),
                'labelNoCount': this.element.data('label-no-count')
            };
            this.addOptions(defaultOptions, options);

            this._registerTabNavigationClickEvent();
            this._registerOptionsClickEvent();
            this._registerRemoveFromTagBarClickEvent();

            this._init();
        };

        LocationWidget.prototype = $.extend({}, Widget.prototype,
            {
                _init: function()
                {
                    var tagTemplate = $('[data-fcse-role="locationwidget--tagitem"][data-tag-id="{TAG_ID}"]',
                        this.element);

                    if (tagTemplate.length) {
                        this._tagTemplate = tagTemplate.detach().get(0).outerHTML;
                    }

                    this.setValueToUi();
                },

                _registerTabNavigationClickEvent: function()
                {
                    var self = this;

                    $('[data-fcse-role="locationwidget--grouptab"]',
                        this.element).on("click", function (e) {
                            var $this = $(this);

                            self._switchTab($this.data('group-id'));
                            e.preventDefault();
                            e.stopImmediatePropagation();
                        });
                },

                _registerOptionsClickEvent: function()
                {
                    var self = this;

                    $('[data-fcse-role="locationwidget--mainoption"], [data-fcse-role="locationwidget--option"]',
                        this.element).on("click", function(e) {
                            var $this = $(this);
                            var cbx = $('[data-fcse-role="locationwidget--cbx"]', $this);
                            var isCbx = $(e.target).is('[data-fcse-role="locationwidget--cbx"]');
                            var isChecked = isCbx ? cbx.is(':checked') : !cbx.is(':checked');
                            var isMainSelected = false;


                            if ($this.is('[data-fcse-role="locationwidget--mainoption"]')) {
                                // Reset options every time mainoption is clicked.
                                self._getContentElement('data-group-id', $this.data('id'))
                                    .find('[data-fcse-role="locationwidget--cbx"]').each(function(i, item){
                                        $(item).prop('checked', false);
                                    });
                            } else {
                                var mainCheckbox = $('[data-fcse-role="locationwidget--mainoption"][data-id="'+
                                              $this.data('group-id') +'"] [data-fcse-role="locationwidget--cbx"]',
                                              self.element);
                                isMainSelected = mainCheckbox.is(':checked');

                                if (isMainSelected) {
                                    // Un-Check MainCheckbox of clicked Checkbox
                                    mainCheckbox.prop('checked', false);
                                    self._removeTag($this.data('group-id'));
                                    isMainSelected = false;
                                    
                                    // Check clicked Checkbox
                                    cbx.prop('checked', isChecked);                            
                                    e.preventDefault();
                                } else if (!isCbx) {
                                    cbx.prop('checked', isChecked);
                                    e.preventDefault();
                                }
                            }
                            
                            
                            if (!isMainSelected) {
                                (isChecked) ? self._addTag($this.data('id')) : self._removeTag($this.data('id'));
                            }
                            e.stopPropagation();
                        });
                },

                _registerRemoveFromTagBarClickEvent: function()
                {
                    var self = this;

                    $('[data-fcse-role="locationwidget--tagbar"]', this.element).on('click',
                        '[data-fcse-role="locationwidget--tagitemremovebtn"]', function() {
                            var id = $(this).closest('[data-tag-id]').data('tag-id');

                            self._getContentElement('data-id', id)
                                .find('[data-fcse-role="locationwidget--cbx"]').prop('checked', false);

                            self._removeTag(id);
                        });
                },

                _switchTab: function(groupId)
                {
                    var activeClassName = this.option('activeClassName');

                    $('[data-fcse-role="locationwidget--grouptab"]', this.element).removeClass(activeClassName)
                        .filter('[data-group-id="' + groupId + '"]').addClass(activeClassName);

                    $('[data-fcse-role="locationwidget--grouptabcontent"]', this.element).hide()
                        .filter('[data-group-id="' + groupId + '"]').show();
                },

                _getContentElement: function(attrName, attrValue) {
                    return $('[data-fcse-role="locationwidget--grouptabcontent"]', self.element)
                        .find('['+ attrName +'="'+ attrValue +'"]');
                },

                _removeTag: function(id)
                {
                    var tagBar = $('[data-fcse-role="locationwidget--tagbar"]', this.element);

                    tagBar.find('[data-fcse-role="locationwidget--tagitem"][data-tag-id="'+ id +'"]').remove();

                    this._showHideTagsPrompt();
                },

                _addTag: function(id) {
                    var option = this._getContentElement('data-id', id);
                    var tagBar = $('[data-fcse-role="locationwidget--tagbar"]', this.element);

                    if (!tagBar.find('[data-fcse-role="locationwidget--tagitem"][data-tag-id="'+id +'"]').length) {
                        if (option.is('[data-fcse-role="locationwidget--mainoption"]')) {
                            this._getContentElement('data-group-id', id).each(function(i, item) {
                                tagBar.find('[data-fcse-role="locationwidget--tagitem"][data-tag-id="'+
                                    $(item).data('id') +'"]').remove();
                            });
                        }

                        var tagTemplate = this._tagTemplate.replace('{TAG_ID}', id)
                            .replace('{TAG_NAME}', option.data('name'));

                        tagBar.append($(tagTemplate));

                        this._showHideTagsPrompt();
                    }
                },

                _showHideTagsPrompt: function()
                {
                    var defaultTag = $('[data-fcse-role="locationwidget--defaulttagitem"]', this.element);

                    (!$('[data-fcse-role="locationwidget--tagitem"]', this.element)
                        .filter(':not([data-tag-id="{TAG_ID}"])').length) ? defaultTag.show() : defaultTag.hide();
                },

                setValueToUi: function()
                {
                    var self = this;
                    var valueArray = this.value;

                    $('[data-fcse-role="locationwidget--tagitem"]', this.element).filter(':not([data-tag-id="{TAG_ID}"])').remove();

                    $('[data-fcse-role="locationwidget--cbx"]', this.element).each(function(i, item) {
                        $(item).prop('checked', false);
                    });

                    _.each(valueArray, function(value, key) {
                        var option = self._getContentElement('data-value', value);

                        option.find('[data-fcse-role="locationwidget--cbx"]').prop('checked', true);
                        self._addTag(option.data('id'));
                    });

                    this._showHideTagsPrompt();
                },

                getValueFromUi: function()
                {
                    var self = this;
                    var value = [];
                    var $selectedItems = $('[data-fcse-role="locationwidget--tagitem"]', this.element);

                    _.each($selectedItems, function(selectedItem, key) {
                        var id = $(selectedItem).data('tag-id');
                        value.push(self._getContentElement('data-id', id).data('value'));
                    });

                    return value;
                },

                formatValue: function()
                {
                    if (!_.isUndefined(this.getValue()) && this.getValue().length > 1) {
                        return this.getValue().length + " " + this.option('labelCount');
                    } else if (_.isUndefined(this.getValue()) || this.getValue().length == 0) {
                        return this.option('labelNoCount');
                    } else {
                        return this._getContentElement('data-value', this.getValue()[0]).data('name');
                    }
                },

                _processData: function(data)
                {
                    var processedData = [];
                    if (_.isString(data)) {
                        processedData = data.length ? data.split(";") : [];
                    } else if (_.isNumber(data)) {
                        processedData = [data];
                    } else if (_.isUndefined(data)){
                        // Allow undefined values for some browsers
                    } else {
                        throw new Error("Only string/integer value is valid for initial value.");
                    }

                    return processedData;
                }
            });

        return LocationWidget;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-locationwidget/locationWidget.js
// module id = 85
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21